<div class="header">
  <div class="header-container">
    <h1 class="header-title-shopper">Account Deletion</h1>
    <br />
    <br />
    <p style="text-align: center">
      Submit your account deletion request to support@zeropay.co.za
    </p>
    <div class="content">
      <br />
      <br />
      <br />
      <mat-divider></mat-divider>
      <br />
      <br />
      <br />
      <h1 class="header-title-shopper-content">
        Didn’t find the answer you were looking for?
      </h1>
      <br />
      <button mat-stroked-button class="btn-action" (click)="showContact()">
        CONTACT US
      </button>
    </div>
  </div>
</div>
